import dayjs from 'dayjs';
import { z } from 'zod';

enum SUMMARY_MESSAGE {
  APPROVAL_DATE = 'กรุณาระบุวันที่ที่คณะกรรมการบริษัทมีมติเห็นชอบ',
}

export const ReviewSummaryReportSchema = z
  .object({
    cgrScoreStatus: z.boolean(),
    draftReportStatus: z.boolean(),
    completedAllSection: z.boolean(),
    committeeApprovalDate: z
      .custom((value) => dayjs.isDayjs(value) && value.isValid(), {
        message: SUMMARY_MESSAGE.APPROVAL_DATE,
      })
      .optional(),
  })
  .superRefine((data, ctx) => {
    const { draftReportStatus, completedAllSection, committeeApprovalDate } =
      data;
    if (
      draftReportStatus === true &&
      completedAllSection === true &&
      !committeeApprovalDate
    ) {
      ctx.addIssue({
        code: 'custom',
        message: SUMMARY_MESSAGE.APPROVAL_DATE,
        path: ['committeeApprovalDate'],
      });
    }
  });
